import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Panel from './LearninPlanBitePanel';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as enviromentHelper from '../../../helpers/environmentHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as appConstants from '../../../constants/appConstants';
import ExitBtn from '../../buttons/ExitButton';
import _ from 'lodash';

class LearningPlanMenu extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            learningPlan: this.props.contentData.experience.learning_plan,
            lessonStatus: userDataHelper.getLessonStatus(this.props.userData.bites),
            fontSize: this.props.fontSize,
            height: undefined,
            updateHeight: false,
            bites: [],
            locale: appHelper.getLocalData(this.props.contentData.experience.learning_plan),
            filter: "required",
            hasOptionalBites: false,
            updateLEarningPlan: false,
            assets: {
                background: {
                    src: "",
                    type: "",
                    type_id: ""
                },
                character: {
                    src: "",
                    pose: "",
                    position: ""
                }
            },
            instruction:"",
            updateInstruction: false,
            show_label: appHelper.getLocaleString("show_label"),
            required_only_label: appHelper.getLocaleString("required_only_label"),
            all_label: appHelper.getLocaleString("all_label"),
            showExitBtn: appHelper.isDefined(this.props.contentData.experience) ? this.props.contentData.experience.include_exit_button : false,
            env: enviromentHelper.getEnvironment(),
        };
        this.getAssets = this.getAssets.bind(this);
        this.getInstruction = this.getInstruction.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setFilterRequired = this.setFilterRequired.bind(this);
        this.setFilterAll = this.setFilterAll.bind(this);
        this.getFilterBtnClass = this.getFilterBtnClass.bind(this);
        this.setPersonalLearningPlanBites = this.setPersonalLearningPlanBites.bind(this);
        //this.jumpToBite = this.jumpToBite.bind(this);
        this.setHeight = _.debounce(this.setHeight.bind(this).bind(this),100);
        this.getHeight = this.getHeight.bind(this);

        this.componentWatcher = _.debounce(this.componentWatcher.bind(this),100);
    }

    componentDidMount() {
        window.addEventListener("resize", this.componentWatcher);
        this.props.actions.setNewLessonLocation(-1);
        this.setPersonalLearningPlanBites();
        this.getAssets();
        this.setHeight();
        this.getInstruction();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                updateLEarningPlan: true
            });
        }

        if (this.state.fontSize !== nextProps.fontSize) {
            this.setState({fontSize: nextProps.fontSize, updateHeight: true});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.contentData.experience.learning_plan),
                show_label: appHelper.getLocaleString("show_label"),
                required_only_label: appHelper.getLocaleString("required_only_label"),
                all_label: appHelper.getLocaleString("all_label"),
                updateInstruction:true,
            });
        }
    }

    componentDidUpdate() {
        if (this.state.updateLEarningPlan) {
            this.setPersonalLearningPlanBites();
        }

        if (this.state.updateHeight) {
            this.setHeight();
        }

        if(this.updateInstruction){
            this.getInstruction();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.componentWatcher);
    }

    componentWatcher(){

        let env = enviromentHelper.getEnvironment();
        if(env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation){
            this.setState({env: Object.assign({}, env)});
            this.setHeight();
        }
    }

    setPersonalLearningPlanBites() {
        this.setState({updateLEarningPlan: false});
        let bites = [];
        let hasOptionalBites = false;

        for (let i = 0; i < this.state.userData.bites.length; i++) {
            let bite = this.state.userData.bites[i];
            if (!bite.required && bite.visible) {
                hasOptionalBites = true;
            }

            bites = dataHelper.immutablePush(bites, bite);
        }
        //if(!appHelper.isDefined(localStorage.menu.reorder_optional_items) || (appHelper.isDefined(localStorage.menu.reorder_optional_items) && localStorage.menu.reorder_optional_items)) {
        bites.sort(function (a, b) {
            if (b.required < a.required) return -1;
            if (b.required > a.required) return 1;
            return 0;
        });
        //}


        this.setState({bites: Object.assign([], bites), hasOptionalBites: hasOptionalBites});


    }

    getAssets() {
        let backgroundAsset = Object.assign(this.state.assets.background);
        let screenCharacter = {};
        let characterAsset = Object.assign(this.state.assets.character);

        if (appHelper.isDefined(this.state.learningPlan.assets.background)) {
            backgroundAsset = appHelper.getBackgroundAsset(this.state.learningPlan.assets.background);
        }

        if (appHelper.isDefined(this.state.learningPlan.assets.character)) {
            screenCharacter = appHelper.getCharacterAsset(this.state.learningPlan.assets.character);
            characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.learningPlan.assets.character);
        }

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: backgroundAsset,
                character: characterAsset,
            })
        });

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getInstruction() {
        let instruction = "";
        if (this.state.lessonStatus !== objectConstants.STATUS_COMPLETE) {
            instruction =  this.state.locale.description;
        } else {
            if (appHelper.isDefined(this.state.locale.completion_text)) {
                instruction =  this.state.locale.completion_text;
            } else {
                instruction =  this.state.locale.description;
            }
        }

        this.setState({instruction: instruction, updateInstruction: false});
    }

    setFilterRequired() {
        this.setState({filter: "required"});
    }

    setFilterAll() {
        this.setState({filter: "all"});
    }

    getFilterBtnClass(value) {
        return value === this.state.filter ? 'active' : '';
    }

    /*jumpToBite(){
        console.log('jump to bite');
        window.parent.postMessage({
            'func': 'setScreenId',
            'message' : {
                'screen_type': 'screen',
                'screen_id': 333
            }
        }, "*");
    }*/

    setHeight() {
        this.setState({updateHeight: false});
        let mainWrapper = document.getElementById('main-wrapper');
        let header = document.getElementById('learningPlanMenuHeader');

        if (appHelper.isDefined(header)) {
            let newHeight = (mainWrapper.offsetHeight - header.offsetHeight);
            this.setState({height: newHeight});
        }
    }

    getHeight() {
        let header = document.getElementById('learningPlanMenuHeader');
        if (header !== null && appHelper.isDefined(this.state.height)) {
            return {
                height: `${this.state.height}px`,
                minHeight: `${this.state.height}px`,
            };
        } else {
            return {};
        }
    }


    render() {
        let Dialog = this.props.dialogPopup.component;
        return (
            <div className="scenario-bite ">
                <div className="scenario-bite-content">
                    <div className="screen-wrapper full-screen">
                        <div className="menu-screen">
                            <div className="background-container">
                                <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                            </div>
                            <div className="screen-container full-screen-tight">
                                <div className="personalised-menu-header include-filter" id="learningPlanMenuHeader">
                                    {this.state.assets.character.src.length > 0
                                        ?
                                            <div className="character-image"><img src={this.getImagePath(this.state.assets.character.src)} alt=""/></div>
                                        :
                                            null
                                    }
                                    <div className={`label-panel ${this.state.showExitBtn ? "include-nav" : ""}`}>

                                        {
                                            appHelper.isDefined(this.state.locale.title) && this.state.locale.title.length > 0
                                                ?
                                                <div className="flex-1">
                                                <h3 className="text-center">{this.state.locale.title}</h3>
                                                </div>
                                                :
                                                null
                                        }
                                        {
                                            this.state.showExitBtn
                                                ?
                                                <div className="nav-item">
                                                    <ExitBtn />
                                                </div>
                                                : null
                                        }
                                    </div>


                                    <div className="filter-panel">
                                        {
                                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0

                                                ?
                                                <div className="instruction-text"
                                                     dangerouslySetInnerHTML={{__html: this.state.instruction}}/>
                                                :
                                                null
                                        }

                                        {
                                           this.state.hasOptionalBites
                                                ?
                                                <div className="inline-block">
                                                    <div className="inline-block">
                                                        <div className="text-right">{this.state.show_label}: &nbsp; &nbsp;</div>
                                                    </div>
                                                    <div className="btn-group text-right">
                                                        <button type="button"
                                                                className={`btn ${this.getFilterBtnClass("required")}`}
                                                                onClick={this.setFilterRequired}>{this.state.required_only_label}
                                                        </button>
                                                        <button type="button"
                                                                className={`btn ${this.getFilterBtnClass("all")}`}
                                                                onClick={this.setFilterAll}>{this.state.all_label}
                                                        </button>


                                                    </div>
                                                </div>
                                                : null
                                        }

                                    </div>
                                </div>
                                <div className="personalised-menu-body" style={this.getHeight()}>
                                    {this.state.bites.length > 0
                                        ?
                                        <ul className="menu-panel-list">
                                            {this.state.learningPlan.bites.map(menuBiteData =>
                                                <li className="panel-item" key={menuBiteData.bite_id}>
                                                    <Panel menuData={menuBiteData}
                                                           bite={appHelper.getBiteById(menuBiteData.bite_id)}
                                                           required={appHelper.getArrayObjectByKey(this.state.bites, "bite_id", menuBiteData.bite_id).required}
                                                           filter={this.state.filter}/>
                                                </li>
                                            )}
                                        </ul>
                                        :
                                        null
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.dialogPopup.render
                        ? <Dialog />
                        : null
                    }

                </div>
            </div>
        );
    }
}

LearningPlanMenu.propTypes = {
    contentData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    fontSize: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    dialogPopup: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

LearningPlanMenu.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        userData: state.userData,
        trackingData: state.trackingData,
        fontSize: state.fontSize,
        dialogPopup: state.dialogPopup,

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearningPlanMenu);



/** WEBPACK FOOTER **
 ** ./src/components/menus/learningPlan/LearningPlanMenu.js
 **/